module.exports = __webpack_public_path__ + "static/media/view3.dd770fa1.jpg";